//EOD
export const EOD_DAILY_SUMMARY_REQUEST = 'EOD_DAILY_SUMMARY_REQUEST';
export const EOD_DAILY_SUMMARY_SUCCESS = 'EOD_DAILY_SUMMARY_SUCCESS';
export const EOD_DAILY_SUMMARY_FAILURE = 'EOD_DAILY_SUMMARY_FAILURE';